import type { Config } from './types';

export const Staging: Partial<Config> = {
  GEM_HOST: 'https://beta.gem.com',
  LAUNCHDARKLY_CLIENT_SIDE_ID: '63617393c7b1a30d739c04b3',
  LEVER_HOST: 'https://hire.sandbox.lever.co',
  SEGMENT_WRITE_KEY: 'pCEpDAvGTOwT6E5LZgJLOmMIAJ5vLnyM',
};
